/* eslint-disable import/no-internal-modules */
/* eslint-disable import/no-unassigned-import */
/*
 * As suggested in the docs, this is the rSchedule
 * setup file. Rather than importing from the
 * rSchedule module directly, you import from this
 * file. For more information see:
 * https://gitlab.com/john.carroll.p/rschedule/-/tree/v1/docs#setup
 */

import '@rschedule/moment-tz-date-adapter/setup';
/*
 * Other date adapters also exist, though
 * you can only import one date adapter in a project.
 * For example:
 *   import '@rschedule/moment-tz-date-adapter/setup';
 */

/*
 * codesandbox has issues with the json-tools module.
 * I think it's just a transpilation issue with codesandbox though.
 *    import "@rschedule/json-tools/setup"; // <-- optional json support
 */

/*
 * export * from "@rschedule/moment-tz-date-adapter";
 * export * from "@rschedule/core";
 */
export * from '@rschedule/core/generators';
// export * from "@rschedule/ical-tools"; // <-- optional ical support
